import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=1fc19b1e&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=1fc19b1e&prod&lang=css&"
import style1 from "./statistics.vue?vue&type=style&index=1&id=1fc19b1e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc19b1e",
  null
  
)

export default component.exports